// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyBM2prVAQGAQTZJ3Twrb5f4otNJAeKGQnA",
    authDomain: "flashstorewebsite.firebaseapp.com",
    databaseURL: "https://flashstorewebsite.firebaseio.com",
    projectId: "flashstorewebsite",
    storageBucket: "flashstorewebsite.appspot.com",
    messagingSenderId: "341131750852",
    appId: "1:341131750852:web:7f1c2876c208ce34acc891",
    measurementId: "G-MZ17YCP6MZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
